"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WebDesignerValue() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}